// extracted by mini-css-extract-plugin
module.exports = {"paths":"styles_paths__2mlma","ProPath":"styles_ProPath__15FgQ","ITIL-4":"styles_ITIL-4__2TNtt"};